const PREVIEW_BASE_DOMAIN = import.meta.env.VITE_PREVIEW_BASE_DOMAIN as string | undefined;

const SAFE_HOSTNAME_RE = /^[a-z0-9-]+$/i;

export function getPreviewUrl(plusWebsiteId: string): string | undefined {
  if (!PREVIEW_BASE_DOMAIN || !plusWebsiteId || !SAFE_HOSTNAME_RE.test(plusWebsiteId))
    return undefined;

  return `https://${plusWebsiteId}.${PREVIEW_BASE_DOMAIN}/preview`;
}
